<template>
  <div>

      <div class="grid grid-cols-3 gap-x-5 w-full">
          <div
              class=" p-1 shadow-lg cursor-pointer my-4 rounded-md text-left outline outline-1 outline-gray-500 hover:outline-gray-300"
              v-for="(connection, index) in connections"
              v-b-modal="connection.modalRef"
              :key="connection.title + '-' + index">
              <div class="font-bold">
                  <span>
                      <img v-if="connection.image" :src="connection.image" class="rounded-sm w-8 h-8"/>
                      <i v-else :class="connection.icon" aria-hidden="true"></i>
                  </span>
                  {{ `${connection.title} ${connection.subTitle ? (" - " + connection.subTitle) : ""}` }}
              </div>
              <div class="m-1 font-light">
                  {{ connection.description }}
              </div>
          </div>
      </div>

      <!-- IMPORT AIRTABLE MODAL -->
      <b-modal ref="import_airtable_modal" :hide-footer="true" size="lg" :id="'import_airtable_modal'" :title="'Import Airtable'">
          <ImportAirtable
              @imported="() => closeModal('import_airtable_modal')">

          </ImportAirtable>
      </b-modal>

      <!-- EXPORT AIRTABLE MODAL -->
      <b-modal ref="export_airtable_modal" :hide-footer="true" size="lg" :id="'export_airtable_modal'" :title="'Export Airtable'">
          <ImportAirtable
              :export-mode="true"
              @exported="() => export_airtable_modal.hide()">

          </ImportAirtable>
      </b-modal>

      <!-- Pipedream modal -->
      <b-modal ref="pipedream_modal" :hide-footer="true" size="lg" :id="'pipedream_modal'" :title="'Pipedream Modal'">
          <Pipedream
              @validated="() => pipedream_modal.hide()">
          </Pipedream>
      </b-modal>

      <!-- Google sheets modal -->
      <b-modal ref="import_google_sheets_modal" :hide-footer="true" size="lg" :id="'import_google_sheets_modal'" :title="'Importer depuis Google sheets'">
          <SheetsModal
              @validated="() => import_google_sheets_modal.hide()">
          </SheetsModal>
      </b-modal>

      <!-- Export vers Google sheets modal -->
      <b-modal ref="export_google_sheets_modal" :hide-footer="true" size="lg" :id="'export_google_sheets_modal'" :title="'Exporter vers Google sheets'">
          <SheetsModal
              :export-mode="true"
              @validated="() => export_google_sheets_modal.hide()">
          </SheetsModal>
      </b-modal>

      <hr/>
      <!-- Google -->
      <div>
          <div class=" text-2xl font-medium">
              Services Google
          </div>
          <Google/>
          <div class="grid grid-cols-3 gap-x-5 w-full">
          <div
              class=" p-1 shadow-lg cursor-pointer my-4 rounded-md text-left outline outline-1 outline-gray-500 hover:outline-gray-300"
              v-for="(connection, index) in googleConnections"
              v-b-modal="connection.modalRef"
              :key="connection.title + '-' + index">
              <div class="font-bold">
                  <span>
                      <img v-if="connection.image" :src="connection.image" class="rounded-sm w-8"/>
                      <i v-else :class="connection.icon" aria-hidden="true"></i>
                  </span>
                  {{ `${connection.title} ${connection.subTitle ? (" - " + connection.subTitle) : ""}` }}
              </div>
              <div class="m-1 font-light">
                  {{ connection.description }}
              </div>
          </div>
      </div>
          
      </div>
  </div>

</template>

<script setup>
import { onMounted, ref } from 'vue';
import airtable_service from "../services/airtable.js";
import ImportAirtable from "../components/connection_modals/import_airtable.vue";
import Pipedream from "../components/connection_modals/pipedream.vue";
import Google from '../components/connection_modals/google.vue';
import SheetsModal from '../components/connection_modals/google_sheets.vue';

const import_airtable_modal = ref(null);
const export_airtable_modal = ref(null);
const pipedream_modal = ref(null);
const import_google_sheets_modal = ref(null);
const export_google_sheets_modal = ref(null);

const connections = ref([
  {
      title: "Import Airtable",
      description: "Importer une table depuis Airtable",
      icon: "fa fa-share-alt",
      image: "https://www.bbb.org/ProfileImages/17382874-098f-4e30-9759-1ac65db6c525.png",
      modalRef: "import_airtable_modal"
  },
  {
      title: "Export Airtable",
      description: "Exporter une table vers Airtable",
      icon: "fa fa-share-alt",
      image: "https://www.bbb.org/ProfileImages/17382874-098f-4e30-9759-1ac65db6c525.png",
      modalRef: "export_airtable_modal"
  },
  // {
  //     title: "Pipedream",
  //     description: "Lancer un workflow pipedream",
  //     icon: "fa fa-share-alt",
  //     image: "https://builtonair.com/uploads/Pipedream-logo-440x440.png",
  //     modalRef: "pipedream_modal"
  // }
]);

const googleConnections = ref([
  {
      title: "Import Google Sheets",
      description: "Importer une feuille Google Sheets",
      icon: "fa fa-share-alt",
      image: "https://martechwithme.com/wp-content/uploads/2020/12/2000px-Google_Sheets_logo.svg.png",
      modalRef: "import_google_sheets_modal"
  },
  {
      title: "Exporter vers Google Sheets",
      description: "Exporter une table vers Google Sheets",
      icon: "fa fa-share-alt",
      image: "https://martechwithme.com/wp-content/uploads/2020/12/2000px-Google_Sheets_logo.svg.png",
      modalRef: "export_google_sheets_modal"
  }

]);

const closeModal = async (modal_id) => {

  import_airtable_modal.value.hide();
}

onMounted(() => {
  // console.log('ConnexionsBDD.vue is mounted!');
});

</script>